export const getSortOptions = (type) => {
    switch (type) {
        case "LEARNING":
            return LEARNING_OPTIONS;
        case "WAITING":
            return WAITING_OPTIONS;
        case "COMPLETION":
            return COMPETION_OPTIONS;
        default:
            return LEARNING_OPTIONS;
    }
}

const LEARNING_OPTIONS = [
    {
        translateKey: "3909",
        sortValue: "created,desc",
        isShow: true,
    },
    {
        translateKey: "3910",
        sortValue: "created,asc",
        isShow: false,
    },
    {
        translateKey: "3911",
        sortValue: "learnStudy,desc",
        isShow: false,
    },
    {
        translateKey: "3912",
        sortValue: "learnStudy,asc",
        isShow: false,
    },
];
const WAITING_OPTIONS = [
    {
        translateKey: "3909",
        sortValue: "created,desc",
        isShow: true,
    },
    {
        translateKey: "3910",
        sortValue: "created,asc",
        isShow: false,
    },
    {
        translateKey: "3911",
        sortValue: "learnStudy,desc",
        isShow: false,
    },
    {
        translateKey: "3912",
        sortValue: "learnStudy,asc",
        isShow: false,
    },
];
const COMPETION_OPTIONS = [
    {
        translateKey: "3913",
        sortValue: "progression,desc",
        isShow: true,
    },
    {
        translateKey: "3914",
        sortValue: "created,desc",
        isShow: false,
    },
    {
        translateKey: "3915",
        sortValue: "created,asc",
        isShow: false,
    },
];